export default "__VITE_ASSET__sv_PN6RN__"